import ReactDOM from 'react-dom';
import React from 'react';
import ReferWidget from './ui/refer-widget';
import { ReferFriendWidget } from './enums/refer-friend-widget';
import store from './dal/store';
import { Provider } from 'react-redux';

/**
 * entry point
 * https://dev.waves.com/refer
 */
const init = () => {
    const $root = document.getElementById('rfr-app');
    if (!$root) return;

    const widgetID = Number($root.getAttribute('data-widget-id') || ReferFriendWidget.MainPage);

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <ReferWidget widgetID={ widgetID } />
            </Provider>
        </React.StrictMode>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});